import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { SearchFilterParams } from "~pages/Conducts/ConductListPage/types/searchFilterParams.ts";
import { transformConductResponse } from "~pages/Conducts/ConductListPage/utilities/transforms.ts";
import type { ConductResponse } from "~types/conduct.ts";

export const useFetchAllConducts = (params: SearchFilterParams, enabled = true) => {
  const enhancedRequest = useApi();
  const { organizationId, sport } = useParams();
  let url = `${sport}/o/${organizationId}/conduct`;
  if (!isEmpty(params)) {
    url += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["conducts", sport, organizationId, params],
    queryFn: async () => {
      const response: ConductResponse = await enhancedRequest(url);
      const data = transformConductResponse(response);
      return { data: data, nextLink: response.links.next };
    },
    enabled,
  });
};
